import React, { useEffect, useLayoutEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { client } from '@Utils'
import { canvasOrgKeyManagement as endpoints } from '@URLS'
import { BootstrapPaginator } from '@CommonComponents'
import { useStateValue } from '../../state'
import OrganizationAttributes from './OrganizationAttributes'
import OrgContextsTable from './OrgContextsTable'

const OrganizationDetails = ({ orgId }) => {
  const [currentState, dispatch] = useStateValue()
  const [currentPage, setCurrentPage] = useState(1)
  const resultsPerPage = 20
  const updatePageNum = ({ pageNum }) => {
    setCurrentPage(pageNum)
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const resp = await client.get(
          endpoints.getOrgDetails({ orgId: orgId, pageNum: currentPage })
        )
        dispatch({
          type: 'selectOrg',
          payload: resp.data.organization,
        })
      } catch (err) {
        console.log(err)
      }
    }
    fetchData()
  }, [currentState.reloadSwitch, currentPage])

  // scroll to top of page on first load
  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const resp = await client.get(endpoints.getContacts())
        dispatch({
          type: 'setContacts',
          payload: resp.data.users,
        })
      } catch (err) {
        console.log(err)
      }
    }
    fetchData()
  }, [currentState.reloadSwitch])

  let component =
    currentState.selectedOrg === null ? (
      <p>Loading...</p>
    ) : (
      <React.Fragment>
        <OrganizationAttributes
          organization={currentState.selectedOrg}
          contacts={currentState.contacts}
        />
        <OrgContextsTable organization={currentState.selectedOrg} />
        <BootstrapPaginator
          itemCount={currentState.selectedOrg.contextCount}
          pageItemLimit={resultsPerPage}
          currentPageNum={currentPage}
          updatePageFunc={updatePageNum}
        />
      </React.Fragment>
    )

  return <React.Fragment>{component}</React.Fragment>
}

OrganizationDetails.propTypes = {
  orgId: PropTypes.string.isRequired,
}

export default OrganizationDetails
